import { api, parseApiError } from './api';
import type {
  RecurringTransaction,
  RecurringListResponse,
  CreateRecurringInput,
  UpdateRecurringInput,
} from '@/types/recurring';

export const recurringService = {
  /**
   * Get all recurring transactions for the authenticated user
   */
  async getRecurring(): Promise<RecurringListResponse> {
    try {
      const response = await api.get<RecurringListResponse>('/api/recurring');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Create a new recurring transaction
   */
  async createRecurring(data: CreateRecurringInput): Promise<RecurringTransaction> {
    try {
      const response = await api.post<RecurringTransaction>('/api/recurring', data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Update a recurring transaction
   */
  async updateRecurring(id: string, data: UpdateRecurringInput): Promise<RecurringTransaction> {
    try {
      const response = await api.put<RecurringTransaction>(`/api/recurring/${id}`, data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Delete a recurring transaction
   */
  async deleteRecurring(id: string): Promise<void> {
    try {
      await api.delete(`/api/recurring/${id}`);
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Manually trigger processing of a recurring transaction
   */
  async processRecurring(id: string): Promise<RecurringTransaction> {
    try {
      const response = await api.post<RecurringTransaction>(`/api/recurring/${id}/process`);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default recurringService;
